import React from "react"
import classes from "./sideMenu.module.scss"

const SideMenu = () => {
  return (
    <aside className={classes.aside}>
      <div>
        <ul className={classes.ul}>
          <li className={classes.item}>
            <a href="/" className={classes.Link}>
              Pradžia
            </a>
          </li>
          <li className={classes.item}>
            <a href="/" className={classes.Link}>
              Paslaugos
            </a>
          </li>
          <li className={classes.item}>
            <a href="/" className={classes.Link}>
              Portfolio
            </a>
          </li>
          <li className={classes.item}>
            <a href="/" className={classes.Link}>
              Kontaktai
            </a>
          </li>
        </ul>
      </div>
    </aside>
  )
}

export default SideMenu
